import { render, staticRenderFns } from "./ModalLicence.vue?vue&type=template&id=097d7592&"
import script from "./ModalLicence.vue?vue&type=script&lang=js&"
export * from "./ModalLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports